<form
  [formGroup]="formData"
  novalidate
  (ngSubmit)="save()"
  [ngClass]="{ submitted: submitted }"
>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body factory_admin">
    <div class="row">
      <div class="col-md-12">
        <fieldset>
          <legend>
            Rfq Clients
            <button
              class="btn btn-sm btn-secondary"
              type="button"
              (click)="addItem()"
            >
              <i class="fas fa-plus"></i> Add row
            </button>
          </legend>
          <table class="table table-stripe">
            <thead>
              <tr>
                <th>Client/s</th>
                <th width="30">&nbsp;</th>
              </tr>
            </thead>
            <tbody formArrayName="line_items">
              <tr
                *ngFor="
                  let item of formData['controls'].line_items['controls'];
                  let idx = index
                "
                [formGroupName]="idx"
              >
                <td>
                  <ng-select
                    [multiple]="false"
                    [trackByFn]="trackByFn"
                    appendTo="body"
                    [clearable]="false"
                    [loading]="clientLoading"
                    [typeahead]="clientInput$"
                    formControlName="item"
                    name="clientProduct"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span *ngIf="item"> {{ item.business_name }} </span>
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      {{ item.business_name }}
                    </ng-template>
                  </ng-select>
                </td>
                <td>
                  <a
                    class="row-action-del"
                    href="javascript:;"
                    (click)="removeItem(idx)"
                  >
                    <i class="fas fa-times text-danger"></i>
                  </a>
                </td> </tr
              ><tr> </tr
            ></tbody>
          </table>
        </fieldset>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      class="btn btn-default mr-1"
      type="button"
      (click)="activeModal.dismiss('')"
    >
      Cancel
    </button>
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="loading"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
    >
      Submit
    </button>
  </div>
</form>
